/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { FibonacciHeapDependencies } from './dependenciesFibonacciHeapClass.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { createSpaClass } from '../../factoriesAny.js';
export var SpaDependencies = {
  FibonacciHeapDependencies,
  addScalarDependencies,
  equalScalarDependencies,
  createSpaClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSpaClass.generated.js
// module id = Dy9s
// module chunks = 3